module.exports = __webpack_public_path__ + "img/temperature.064748d0.png";